// SCRUM-449: every campaign time is shown in Central, labelled — the
// operators are in Texas whatever the event's own zone. "Sep 19, 7:00 PM CT".
export const fmtCT = (iso) =>
  iso
    ? `${new Date(iso).toLocaleString('en-US', {
        timeZone: 'America/Chicago',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })} CT`
    : '—';
